<template>
  <!-- Owner item 3.1: All | Active | Inactive | Banned. The host page keeps
       this row outside its DataTable, whose toolbar disappears on an empty
       page; the chips must stay reachable whatever the result. -->
  <div class="account-state-filter">
    <v-tooltip v-for="chip in chips" :key="chip.key" bottom max-width="320">
      <template v-slot:activator="{ on }">
        <v-chip
          v-on="on"
          :color="chip.color"
          :outline="chip.key !== value"
          :selected="chip.key === value"
          :text-color="chip.key === value ? 'white' : undefined"
          @click="select(chip.key)"
        >
          {{ chip.label }}<template v-if="counts"> ({{ chip.count }})</template>
        </v-chip>
      </template>
      <span>{{ chip.tip }}</span>
    </v-tooltip>
    <span v-if="countsFailed" class="account-state-filter__failed">
      {{ $t("accountState.countsFailed") }}
    </span>
  </div>
</template>

<script>
import { ACCOUNT_STATE_COLORS, ACCOUNT_STATE_FILTERS } from "@/constants/accountState";

export default {
  name: "AccountStateFilter",
  props: {
    // v-model: 'all' | 'active' | 'inactive' | 'banned'
    value: { type: String, default: "all" },
    // { all, active, inactive, banned } from state-counts; null hides counts.
    counts: { type: Object, default: null },
    // Activity window (days) reported with the counts; null when unknown.
    windowDays: { type: Number, default: null },
    // Which rule texts the tooltips explain.
    entity: {
      type: String,
      required: true,
      validator: (value) => ["captain", "passenger"].indexOf(value) !== -1,
    },
    countsFailed: { type: Boolean, default: false },
  },
  computed: {
    chips() {
      return ACCOUNT_STATE_FILTERS.map((key) => ({
        key,
        color: ACCOUNT_STATE_COLORS[key],
        label: this.$t("accountState." + key),
        count: this.counts ? this.counts[key] : null,
        tip: this.tipFor(key),
      }));
    },
  },
  methods: {
    tipFor(key) {
      const rule = this.$t(`accountState.tips.${this.entity}.${key}`);
      // The window only shapes Active / Inactive; its length comes with the
      // counts, so the sentence is left out while it is unknown.
      if ((key === "active" || key === "inactive") && this.windowDays) {
        return rule + " " + this.$t("accountState.tips.window", { days: this.windowDays });
      }
      return rule;
    },
    select(key) {
      if (key !== this.value) this.$emit("input", key);
    },
  },
};
</script>

<style>
.account-state-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.account-state-filter .v-chip,
.account-state-filter .v-chip .v-chip__content {
  cursor: pointer;
}

.account-state-filter__failed {
  color: #8599a3;
  font-size: 12px;
  margin-inline-start: 8px;
}
</style>
